export enum EntryPassStatus {
    draft = 'DRA',
    active = 'ACT',
    retired = 'RET'
}

export enum EntryPassVisibility {
    public = 'PUB',
    unlisted = 'UNL',
    staffOnly = 'STA'
}

export enum EntryPassDiscountType {
  currency = 'CUR',
  percentage = 'PER'
}

export enum EntryPassGiftDiscountType {
  currency = 'CUR',
  percentage = 'PER'
}

export enum CustomerEntryPassStatus {
  awaitingPayment = 'PAY',
  active = 'ACT',
  depleted = 'DEP',
  expired = 'EXP',
  removed = 'REM',
}
